export const formatTimestampToString = (timestamp: Date | undefined) => {
  if (!timestamp) return "";
  try {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${formattedDate} ${formattedTime}`;
  } catch (e) {
    console.error("Error formatting timestamp to string", e);
    return "";
  }
};
